/* eslint-disable no-console */
import { Box } from '@chakra-ui/react';
import React, { useRef } from 'react';
import { NodeTypes } from 'reactflow';
import { v4 as uuidv4 } from 'uuid';

import { DbTable } from '@finley-technologies/finley-types';

import { useInstanceGraph } from '../../hooks/instanceGraphContext';
import { NodeWithHandles } from './NodeWithHandles';
import { ReactFlowWrapperControl } from 'packages/common-frontend/components/ReactFlow';

const nodeTypes: NodeTypes = DbTable.ArtifactTypeIterable.reduce<NodeTypes>(
  (acc, artifactType) => ({
    ...acc,
    [artifactType]: NodeWithHandles,
  }),
  {},
);

export const GraphRenderer = () => {
  const { state, setSelectedNode, selectedNodeId } = useInstanceGraph();
  const elementRef = useRef<HTMLDivElement>(null);

  const nodes = state.nodes.map((node) => {
    return {
      id: node.artifact.id,
      type: node.artifact.type,
    };
  });

  const edges: {
    id: string;
    source: string;
    target: string;
  }[] = state.edges.map((edge) => {
    return {
      id: uuidv4(),
      source: edge.source,
      target: edge.target,
    };
  });

  return (
    <Box
      ref={elementRef}
      resize="both"
      overflow="auto"
      width="100%"
      height={800}
      border="1px solid #ccc"
    >
      <ReactFlowWrapperControl
        elementRef={elementRef}
        nodeTypes={nodeTypes}
        initialNodes={nodes}
        initialEdges={edges}
        onNodeClicked={(node) => {
          if (node && node.id !== selectedNodeId) {
            setSelectedNode(node.id);
          }
        }}
        xSpacing={400}
        ySpacing={300}
        disconnectedSpacing={400}
      />
    </Box>
  );
};
